import RequestPageIcon from '@mui/icons-material/RequestPage';
//import CurrencyExchangeTwoToneIcon from '@mui/icons-material/CurrencyExchangeTwoTone';
//import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LockResetIcon from '@mui/icons-material/LockReset';

const LinksMenu = [
    {
        label: "Redefinir Senha",
        url: "/redefinirSenha",
        disabled: "false",
        icon:<LockResetIcon color='primary'/>
    },
//    {
//        label: "Configurações",
//        url: "/sistema",
//        disabled: "false",
//        icon: <MiscellaneousServicesIcon color='primary' />
//    },
    {
      label: "Dashboard",
       url: "/dashboard",
      disabled: "false",
       icon: <DashboardIcon color='primary' />
   },
//    {
//        label: "Reembolso",
//        url: "/reembolso",
//        disabled: "false",
//        icon: <CurrencyExchangeTwoToneIcon color='primary' />
//    },
    {
        label: "Fatura",
        url: "/fatura",
        disabled: "false",
        icon: <RequestPageIcon color='primary' />
    }
];

//const urlBackend = 'http://localhost:8080'
// const urlBackend='https://portalhmlg.cntour.com.br'
const urlBackend='https://sica.cntour.com.br'

export { LinksMenu, urlBackend }


